import { render, staticRenderFns } from "./login-code.vue?vue&type=template&id=beef95d2&scoped=true&"
import script from "./login-code.vue?vue&type=script&lang=js&"
export * from "./login-code.vue?vue&type=script&lang=js&"
import style0 from "./login-code.vue?vue&type=style&index=0&id=beef95d2&prod&scoped=true&lang=less&"
import style1 from "./login-code.vue?vue&type=style&index=1&id=beef95d2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beef95d2",
  null
  
)

export default component.exports